import { useCallback, useMemo, useRef } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { setBlur, setShowPrivacyDialog } from "../../redux/reducers/uiReducer";

import { logDebug } from "../../utils/logger";
import { isEmpty } from "../../utils/validators";

function PrivacyDialog() {
  const { t } = useTranslation();

  const dialogRef = useRef(null);

  const dispatch = useDispatch();
  const { ui } = useSelector((state) => state);
  const { contact_z_index } = ui;

  const zIndex = useMemo(() => {
    return !isEmpty(contact_z_index) ? parseInt(contact_z_index) : 101;
  }, [contact_z_index]);

  const onClickCloseDialogHandler = useCallback(
    (evt) => {
      logDebug("PrivacyDialog", "onClickCloseDialogHandler", { evt: evt });
      dispatch(setBlur(false));
      dispatch(setShowPrivacyDialog(false));
    },
    [dispatch]
  );

  return (
    <>
      <div className="wrapper" style={{ zIndex: zIndex + 2 }}></div>
      <div
        ref={dialogRef}
        className="privacy-dialog"
        style={{ zIndex: zIndex + 3 }}
      >
        <div className="privacy-dialog__header">
          <span className="privacy-dialog__header__logo"></span>
          <div className="privacy-dialog__header__title header-3">
            {t("privacy.title")}
          </div>
          <div className="privacy-dialog__header__subtitle text-body">
            {t("privacy.description")}
          </div>
          <span
            className="privacy-dialog__header__icon icon-close"
            title={t("button.close")}
            onClick={(evt) => onClickCloseDialogHandler(evt)}
          />
        </div>
        <div className="privacy-dialog__body">
          <div
            className="privacy-dialog__body__content"
            dangerouslySetInnerHTML={{
              __html: t("privacy.content", {
                interpolation: { escapeValue: true },
              }),
            }}
          ></div>
        </div>
        <div className="privacy-dialog__footer"></div>
      </div>
    </>
  );
}

export default PrivacyDialog;
